export enum ProductFormMode {
    Add = 'add',
    Update = 'update'
}